import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { CheckboxModule } from 'primeng/checkbox'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { DividerModule } from 'primeng/divider'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { FocusTrapModule } from 'primeng/focustrap'
import { InputTextModule } from 'primeng/inputtext'
import { RippleModule } from 'primeng/ripple'
import { SelectModule } from 'primeng/select'
import { TagModule } from 'primeng/tag'
import { TooltipModule } from 'primeng/tooltip'

import { MetadataComponent } from './metadata.component'
import { TypeGenericModule } from './types/type-generic/type-generic.module'

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    ButtonModule,
    InputTextModule,
    ConfirmDialogModule,
    SelectModule,
    FocusTrapModule,
    CheckboxModule,
    TooltipModule,
    DividerModule,
    TagModule,
    TypeGenericModule,
    RippleModule,
    MetadataComponent,
  ],
  exports: [
    MetadataComponent,
  ],
  providers: [
    DynamicDialogRef, DynamicDialogConfig,
  ],
})
export class MetadataModule {}
